import { render } from "./FilePublicOfert.vue?vue&type=template&id=4201fd48&scoped=true"
import script from "./FilePublicOfert.vue?vue&type=script&lang=js"
export * from "./FilePublicOfert.vue?vue&type=script&lang=js"

import "./FilePublicOfert.vue?vue&type=style&index=0&id=4201fd48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4201fd48"]])

export default __exports__